// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"oW","sticky_header_title":"pW","stycky_header_title_mob":"qW","root_scroller":"rW","scroller":"sW","indicator":"tW","scrollButtons":"uW","selected":"vW","root_tab_scrollable":"wW","root_scroller_mob":"xW","scroller_mob":"yW","indicator_mob":"zW","selected_mob":"AW","root_tab_mob":"BW","root_tab_mob_scrollable":"CW","sticky_header_title_mob":"EW"};
    if(module.hot) {
      // 1713211525844
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  